import { useTranslation } from 'react-i18next';
import { useGetRequiredRule, useGetSlugRule, useLengthValidationRule } from '@/hooks';
import { CreateProductFormFieldsNames } from '../helpers/types';

export const useCreateProductValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const requiredRule = useGetRequiredRule({ t });
  const slugRule = useGetSlugRule({ t });
  const filedLength = useLengthValidationRule({ t, min: 1, max: 10 });

  return {
    [CreateProductFormFieldsNames.STORE_ID]: [requiredRule],
    [CreateProductFormFieldsNames.LOCALE]: [requiredRule],
    [CreateProductFormFieldsNames.SLUG]: [slugRule],
    [CreateProductFormFieldsNames.EXTERNAL_ID]: [requiredRule],
    [CreateProductFormFieldsNames.UKTZED]: [requiredRule, filedLength],
    [CreateProductFormFieldsNames.IMPORTED]: [requiredRule],
    [CreateProductFormFieldsNames.WEIGHT]: [requiredRule],
    [CreateProductFormFieldsNames.WIDTH]: [requiredRule],
    [CreateProductFormFieldsNames.LENGTH]: [requiredRule],
    [CreateProductFormFieldsNames.HEIGHT]: [requiredRule],
    [CreateProductFormFieldsNames.IS_CUSTOM_ORDER]: [requiredRule],
    [CreateProductFormFieldsNames.UNIT_CODE]: [requiredRule],
  };
};
